import MyLoan from './MyLoan'

export default MyLoan
